import { cleanObject } from '@/common/functions/cleanObject';
import Api from '../api';
import { errorHandler } from '../common';

const queryString = require('query-string');
const { axios: api } = Api;

export const listCallAnalyses = (payload) =>
	errorHandler(async () => {
		const data = await api.get(
			`/call-analysis?` +
				queryString.stringify(cleanObject(payload), {
					arrayFormat: 'bracket',
				}),
		);
		return { data: data.data };
	});

export const getCallAnalysisById = (id) =>
	errorHandler(async () => {
		const data = await api.get(`/call-analysis/${id}`);
		return { data: data.data };
	});

export const getCallAnalysisByCallingInformationId = (callingInformationId) =>
	errorHandler(async () => {
		const data = await api.get(
			`/call-analysis/by-calling-information/${callingInformationId}`,
		);
		return { data: data.data };
	});

export const analyzeCallByCallingInformationId = (
	callingInformationId,
	force = false,
) =>
	errorHandler(async () => {
		const data = await api.post(
			`/call-analysis/analyze/calling-information/${callingInformationId}`,
			{ force },
		);
		return { data: data.data };
	});

export const manualReviewCallAnalysis = (id, body) =>
	errorHandler(async () => {
		const data = await api.patch(`/call-analysis/${id}/manual-review`, body);
		return { data: data.data };
	});

export const getCallAnalysisReport = (payload) =>
	errorHandler(async () => {
		const data = await api.get(
			`/call-analysis/report/summary?` +
				queryString.stringify(cleanObject(payload), {
					arrayFormat: 'bracket',
				}),
		);
		return { data: data.data };
	});

export const getCallAnalysisConfig = () =>
	errorHandler(async () => {
		const data = await api.get(`/call-analysis/config/active`);
		return { data: data.data };
	});

export const getAllCallAnalysisConfigs = () =>
	errorHandler(async () => {
		const data = await api.get(`/call-analysis/config/all`);
		return { data: data.data };
	});

export const updateCallAnalysisConfig = (id, body) =>
	errorHandler(async () => {
		const data = await api.put(`/call-analysis/config/${id}`, body);
		return { data: data.data };
	});

export const createCallAnalysisConfig = (body) =>
	errorHandler(async () => {
		const data = await api.post(`/call-analysis/config`, body);
		return { data: data.data };
	});

export const getCallAnalysisPromptPreview = (body) =>
	errorHandler(async () => {
		const data = await api.post(`/call-analysis/config/prompt-preview`, body);
		return { data: data.data };
	});
